import Swal from "sweetalert2";

let peticionesEnCurso = 0;
let inicioSwalTramitando = 0;
let temporizadorDeCierre = null;
const DURACION_MINIMA_SWAL_MS = 400;
const MARCA_SWAL_TRAMITANDO = "apataxiSwalTramitando";

function cerrarCuandoQuedeInactiva() {
  if (peticionesEnCurso > 0) return;

  const popup = Swal.getPopup();
  if (popup?.dataset?.[MARCA_SWAL_TRAMITANDO] !== "true") return;

  const restante = DURACION_MINIMA_SWAL_MS - (Date.now() - inicioSwalTramitando);
  if (restante <= 0) {
    Swal.close();
    return;
  }

  if (temporizadorDeCierre !== null) clearTimeout(temporizadorDeCierre);
  temporizadorDeCierre = setTimeout(() => {
    temporizadorDeCierre = null;
    if (peticionesEnCurso === 0) cerrarCuandoQuedeInactiva();
  }, restante);
}

export function mostrarSwalTramitando() {
  peticionesEnCurso += 1;
  if (peticionesEnCurso !== 1) {
    if (temporizadorDeCierre !== null) {
      clearTimeout(temporizadorDeCierre);
      temporizadorDeCierre = null;
    }
    return;
  }

  if (temporizadorDeCierre !== null) {
    clearTimeout(temporizadorDeCierre);
    temporizadorDeCierre = null;
  }

  const popupActual = Swal.getPopup();
  if (popupActual?.dataset?.[MARCA_SWAL_TRAMITANDO] === "true") return;

  if (Swal.isVisible()) return;
  inicioSwalTramitando = Date.now();

  const customClass = { popup: "apataxi-swal-loading" };
  if (
    typeof document !== "undefined" &&
    document.querySelector(".MuiAppBar-positionFixed")
  ) {
    customClass.container = "apataxi-swal-content-container";
  }

  Swal.fire({
    position: "center",
    width: "auto",
    padding: 0,
    background: "transparent",
    backdrop: "#ffffff",
    html: '<div class="apataxi-loading-dots" role="status" aria-label="Cargando"><span></span><span></span><span></span></div>',
    customClass,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCloseButton: false,
    showConfirmButton: false,
    showCancelButton: false,
    didOpen: () => {
      const popup = Swal.getPopup();
      if (popup) popup.dataset[MARCA_SWAL_TRAMITANDO] = "true";

      cerrarCuandoQuedeInactiva();
    },
  });
}

export function cerrarSwalTramitando() {
  if (peticionesEnCurso === 0) return;

  peticionesEnCurso -= 1;
  if (peticionesEnCurso > 0) return;

  cerrarCuandoQuedeInactiva();
}

export function showSuccess(mensaje = "La operación se completó correctamente.") {
  return Swal.fire({
    title: mensaje,
    icon: "success",
    confirmButtonText: "Aceptar",
  });
}

export function showError(mensaje = "No se pudo completar la operación.") {
  return Swal.fire({
    title: "Error",
    text: mensaje,
    icon: "error",
    confirmButtonText: "Aceptar",
  });
}
